module.exports = __webpack_public_path__ + "img/iPhone_02.aa458590.png";